const errors = {
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
export const rangeError = (type)=>{
    throw new RangeError(errors[type]);
};
export const checkOverflow = (lower, upper, { gte = false, error } = {})=>{
    if (gte ? lower >= upper : lower > upper) {
        throw new RangeError(error ? errors[error] : 'Overflow: input needs wider integers to process');
    }
};

//# sourceMappingURL=errors.js.map